import { render, staticRenderFns } from "./JF.vue?vue&type=template&id=013d0639&scoped=true"
import script from "./JF.vue?vue&type=script&lang=js"
export * from "./JF.vue?vue&type=script&lang=js"
import style0 from "./JF.vue?vue&type=style&index=0&id=013d0639&prod&lang=css"
import style1 from "./JF.vue?vue&type=style&index=1&id=013d0639&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d0639",
  null
  
)

export default component.exports